<template>
    <fragment>
        <div class="iconBox" :class="{ 'iconBox-margin': bowImg }" v-if="!isShopIcon" @click.prevent="disabledTileClicked">
            <router-link :is="isRAFDisabled ? 'div' : 'router-link'" :to="{ name: icon.route }" class="iconBox__link" :class="{isRAFDisabled: isRAFDisabled}" :target="target">
                <img v-if="newDashboard && bowImg" :src="bowImg" class="ribbon-img" alt="xmas-ribbon">
                <div v-if="isGiftingDatesIcon && hasSpecialDatesCoupon && specialDates && specialDates.length < 3" class="specialDates__offer">

                    <p>{{specialDatesDiscountText}}</p>
                </div>
                <div class="iconBox__container">
                    <div class="iconBox__icon">
                        <img :src="iconUrl" :alt="icon.label" class="iconBox__image"/>
                    </div>
                    <p v-html="icon.label" class="iconBox__label"></p>
                    <p v-if="isRAFDisabled" class="iconBox__label blocked-text">{{$t('DASHBOARD_TILES_RAF_UNLOCK_TEXT')}}</p>
                    <div v-if="counterNumber && !isRAFDisabled" class="iconBox__counter" v-text="counterNumber"></div>
                    <img v-if="isGiftingIcon && hasGiftingCoupon" class="iconBox__offerBadge" :src="giftingOfferBadge" />
                </div>
                <div class="tile-lock" v-if="showLocked">
                    <img src="@/assets/images/decoration/icons/padlock-white.svg" alt="Tile locked">
                </div>
                <div v-if="isRAFDisabled && RAFToolTip" class="toolTipText">
                    <div class="toolTipText--content">
                        <p class="toolTipText--title">{{$t(RAFToolTip.title)}}</p>
                        <p class="toolTipText--text">{{$t(RAFToolTip.text)}}</p>
                    </div>
                </div>
            </router-link>
        </div>
        <div class="iconBoxShop" v-else>
            <router-link :to="isLoaded ? { name: icon.route } : '' " class="iconBoxShop__link" :class="{'disabled-tiles' : !isLoaded}" :target="target">
                <img :src="iconUrl" :alt="icon.label" class="iconBoxShop__image"/>
            </router-link>
        </div>
    </fragment>
</template>

<script>
import { mapGetters } from 'vuex';
import { Fragment } from 'vue-fragment';

export default {

    name: 'IconBox',
    props: {
        icon: {
            required: true,
            type: Object,
        },
        hasGiftingCoupon: {
            default: false,
            type: Boolean,
        },
        isLoaded: {
            default: false,
        },
    },
    components: { Fragment },
    data() {
        return {
            showToolTipModal: false,
        };
    },
    computed: {
        ...mapGetters({
            specialDatesCoupon: 'account/getSpecialDatesCoupon',
            canRefer: 'account/getUserCanRefer',
            specialDates: 'specialDates/getSpecialDates',
            newDashboard: 'account/getDashboardV2Enabled',
            paidOrders: 'account/getUserHasPaidOrders',
            failedLastPayment: 'account/getUserHasFailedLastPayment',
            currency: 'localisation/getCurrency',
            themes: 'account/getThemes',
        }),
        hasSpecialDatesCoupon() {
            return !this.specialDatesCoupon?.special_dates_gifting_coupon_redeemed && this.specialDatesCoupon?.amount !== null;
        },
        discountAmount() {
            return `${this.specialDatesCoupon?.discount_type === 'amount' ? this.currency : ''}${Number(this.specialDatesCoupon?.amount || 0)}${this.specialDatesCoupon?.discount_type === 'percentage' ? '%' : ''}`;
        },
        specialDatesDiscountText() {
            return this.$t('SPECIAL_DATES_DASHBOARD_TILE_DISCOUNT_TEXT', { amount: this.discountAmount });
        },
        counterNumber() {
            return this.icon.counterGetterName ? this.$store.getters[this.icon.counterGetterName] : null;
        },
        iconUrl() {
            return this.isShopIcon ? require(`@/assets/images/pages/account/dashboard/${this.icon.image}.svg`) : require(`@/assets/images/pages/account/dashboard/${this.icon.image}.png`);
        },
        isShopIcon() {
            return this.icon.label === 'Shop';
        },
        isGiftingDatesIcon() {
            return this.icon.label === 'Gifting Reminders';
        },
        isGiftingIcon() {
            return this.icon.image === 'gift';
        },
        giftingOfferBadge() {
            return this.hasGiftingCoupon ? require(`@/assets/images/pages/account/dashboard/offer-badge.svg`) : {};
        },
        target() {
            return this.icon.target ? this.icon.target : '_self';
        },
        showLocked() {
            return this.isRAFDisabled;
        },
        RAFToolTip() {
            if (!this.paidOrders) return { title: 'DASHBOARD_TILES_RAF_NO_PAYMENTS_TITLE' };
            if (this.failedLastPayment) return { title: 'DASHBOARD_TILES_RAF_FAILED_PAYMENT_TITLE', text: 'DASHBOARD_TILES_RAF_FAILED_PAYMENT_TEXT' };
            return null;
        },
        isRAFDisabled() {
            return this.icon.route === 'account.free-flowers' && !this.canRefer;
        },
        bowImg() {
            return this.themes?.top?.icon;
        },
    },
    methods: {
        disabledTileClicked() {
            if (this.isRAFDisabled && window.innerWidth < 767) this.$root.$emit('show-tool-tip-modal', this.RAFToolTip);
        },
    },
};
</script>

<style lang="scss" scoped>
    .specialDates__offer {
        position: absolute;
        width: 86px;
        height: 26px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        top: 0;
        right: 0;
        padding: 4px 8px;
        background-repeat: no-repeat;
        background-color: #63a75e;
        & p {
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            line-height: 1px;
            width: 70px;
        }
    }
    .isRAFDisabled {
        border-style: dashed;
        & .toolTipText {
         visibility: hidden;
         opacity: 0;
         background: #262323;
         color: #fff;
         text-align: center;
         padding: 0 15px;
         box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.2);
         border-radius: 8px;
         position: absolute;
         left: -50%;
         width: 200%;
         z-index: 10;
         transition: opacity 0.3s ease-in-out;
         &--title, &--text {
            font-size: 15px;
         }
         &--title {
            font-weight: 600;
         }
        }
        @media (min-width: 768px) {
            &:hover .toolTipText {
             visibility: visible;
             opacity: 1;
            }
        }
    }
    .tile-lock {
        width: 40px;
        height: 40px;
        position: absolute;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        background: #262323;
        display: flex;
        align-items: center;
        justify-content: center;
        & img {
            height: 20px;
        }
    }
    .toolTip-modal {
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 100;
    }
    .blocked-text {
        color: #AE4743;
        text-decoration: underline;
        padding-top: 5px;
    }
    .ribbon-img {
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
        top: -36px;
        height: 36px;
        width: 72px;
    }
    .iconBox-margin {
        margin-bottom: 28px;
    }
</style>
